export const STATIC_TRANSLATIONS = {
    et: {
        'skeleton.loading': 'Andmete laadimine'
    },
    en: {
        'skeleton.loading': 'Loading'
    },
    ru: {
        'skeleton.loading': 'Загрузка данных'
    }
};
